module.exports = __webpack_public_path__ + "static/media/signup-image-3.71227f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/signup-image-3.jpg
// module id = 957
// module chunks = 0